
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserModule } from '../../store/modules/user'
import { CourseModule } from '../../store/modules/course'
import vuedraggable from 'vuedraggable'
import Sortable from 'sortablejs'
  @Component({
    components: { vuedraggable}
  })
  

export default class ReserveCourse extends Vue {
    @Prop() dialogReserveCourse: boolean
    @Prop() courseId: string
    
    @Prop() courseObj: any = {} // 父组件传入course对象
    @Prop() courseTitleList: any = []
    @Prop() propSelectBaseCourseId: string

    tempCourseList: any = []
    tempCourseObj: any = {}
    // 学员列表
    sList: any = []
    oldList: number[] = []
    newList: number[] = []
    sortable: Sortable | null = null
    list: any = []
    addReserveCourse: any = {}
    selectBaseCourseID: string = null
    zskStudent: string = null

    createCourse: string = '1'
    course_number: number = null
    setZskDate: any = []
    zskWeekDay: any = []
    startTime: number = 0 // 创建课程表时间戳

    // 关联上级学员的套餐列表
    studentPacketList: any = []
    zskStudentPacket: string = null
    is_other: boolean = false

    current_packet: any = {}

    @Watch('dialogReserveCourse')
    getDialog(newVal, oldVal) {
      if (newVal) {
        this.$nextTick(() => {
            this.selectBaseCourseID = this.propSelectBaseCourseId
            this.getStudent("")
        })
      }
    }
    @Watch('propSelectBaseCourseId')
    getId(newVal, oldVal){
      console.log(newVal, 'newVal')
      this.$nextTick(() => {
        this.selectBaseCourseID = this.propSelectBaseCourseId
      })
    }

    close(ctype=1) {
      this.studentPacketList = null
      this.sList = null
      this.zskStudentPacket = null
      this.zskStudent = null
      this.selectBaseCourseID = null
      this.$emit('close', {type: false, data: [], 'ctype': ctype})
    }
    changeZskTime(val){
      console.log("changeZskTime")
      const end = new Date(Date.parse(<any>new Date(val[1])) + 24 * 60 * 60 * 1000 - 1000)
      this.setZskDate = [val[0], end]
    }

    async getStudent(query){
      const controller = new AbortController()
      controller.abort()
      const res: any = await UserModule.studentIsCourse({ org_id: '', name: query, is_course: '1' })
      if (res.code === 200) {
        this.sList = res.data.list
        for (let i=0; i < this.sList.length; i++){
          const _obj = this.sList[i]
          this.current_packet[[_obj.id]] = _obj.current_packet_id
        }
      }
    }

    async getStudentPacket(){
      console.log('getStudentPacket')
    }

    async changeZskStudentPacket(){
      // 获取当前选中学员的套餐列表
      console.log('changeZskStudentPacket')
      console.log(this.zskStudent)
      const res: any = await CourseModule.getPacket({ packet_id: this.current_packet[[this.zskStudent]]})
      if (res.code === 200){
        this.studentPacketList = res.data
        if (this.studentPacketList.length === 1){
          this.zskStudentPacket = this.studentPacketList[0].id
          this.is_other = this.studentPacketList[0].is_other === 1 ? true : false
          
          let allowed = await this.packetAllowdOther()
          if (!allowed){
            return
          }
        }
      }
    }

    makeData(){
      // 组织form数据提交
      const data = {
        "course_id": this.courseId,
        "student_id": this.zskStudent,
        "base_course_id": this.selectBaseCourseID,
        "packet_id": this.zskStudentPacket
      }
      return data
    }

    multiple(){
      let week_day: string = this.zskWeekDay.toString()
      if (this.createCourse == '1') {
        this.setZskDate = []
        this.course_number = 1
      }
      // 设置上课日期
      let time:any = this.setZskDate
      let start_date:any = ''
      let end_date: any = ''
      if (time && time.length > 0) {
        start_date = Date.parse(time[0]) / 1000
        end_date = Date.parse(time[1]) / 1000
      }
      this.start_time = this.courseObj.start_time
      let d = {
        'start_time': this.startTime,
        'start_date': Number(start_date),
        'end_date': Number(end_date),
        'week_day': week_day,
        'course_number': this.course_number,
        "multiple": 1
      }
      console.log(d, 'mdata')
      return d
    }

    async packetAllowdOther(){
      console.log(this.zskStudentPacket, 'packet')
      const packetRes = await CourseModule.PacketBaseCourseTrue({packet_id: this.zskStudentPacket, base_course_id: this.selectBaseCourseID})
      if (packetRes.code === 400){
          this.$message({
            type: "error",
            message: packetRes.message
          })
          return false
      }
      return true
    }

    async addSign(){
      /**
       * 确认约课
       * */
      // 学员套餐是否允许预约其他课
      // 如果不能预约其他课，就与选中的课程与套餐内的课程匹配，未匹配到则提醒
      console.log(this.is_other, 'other')
      if (!this.is_other){
        let allowed = await this.packetAllowdOther()
        if (!allowed){
          return
        }
      }
      let data = this.makeData()
      if (this.createCourse === '2'){
        // 组织批量约课数据
        let mdata = this.multiple()
        data = Object.assign({}, data, mdata)
        console.log(data, 'data======')
      }

      // 创建数据
      const res: any = await CourseModule.reserveCourseSign(data)
      if (res.code === 200) {
        this.$message({
          type: 'success',
          message: '添加成功!'
        })
        this.list = res.data
        console.log("addDPacketBaseCourse")
        this.close(2)
      } else {
        this.$message({
          type: 'error',
          message: res.message
        })
      }

    }

    mounted() {
      
    }
}
